'use strict';

/* App Module */

var app = angular.module('app', [
    'ngRoute',
    'ngAnimate',
    'ngResource',
    'LocalStorageModule',
    'infinite-scroll',
    'ngDialog',
    'fcsa-number',
    'app.config',
    'pusher-angular'
]);

app.run(['$rootScope', '$location', 'localStorageService', '$http', 'Router', 'Braintree', 'User', '$timeout', '$pusher', 'env_config', 'global_config',
    '$routeParams', 'Helper', 'AwsCognito',
    function ($rootScope, $location, localStorageService, $http, Router, Braintree, User, $timeout, $pusher, env_config,
              global_config, $routeParams, Helper, AwsCognito) {

        // Initialize pusher service
        if (typeof env_config.pusher.cluster !== "undefined" && env_config.pusher.cluster != "") {
            window.pusher = new Pusher(env_config.pusher.key, {
                encrypted: true,
                cluster: env_config.pusher.cluster
            });
        } else {
            window.pusher = new Pusher(env_config.pusher.key);
        }

        $rootScope.fb_app_id = env_config.fb_app_id;
        $rootScope.apple_itunes_app_id = env_config.apple_itunes_app_id;
        $rootScope.api_url = env_config.api_url;

        $http.defaults.headers.common['X-WAAVE-DEVICE'] = global_config.x_waave_device;
        $http.defaults.headers.common['X-WAAVE-APP-VERSION'] = global_config.x_waave_app_version;

        // keep user logged in after page refresh
        $rootScope.globals = localStorageService.get('globals') || {};

        if ($rootScope.globals.currentUser) {
            $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.cognito_id_token;
        }

        // if we are on ticketed event redirect to landing page 
        if( typeof $routeParams.event_name != 'undefined'){
            var current = window.location.hash.substr(1);

            if( current.indexOf('/event') == -1 ){
                $location.path('/event');
            }
        }

        if (Helper.getCookie('bannerClosed') == "") {
            $('.banner').show();
        }

        /**
         * Redirect user to app when they click View button on banner
         */
        $rootScope.redirectToApp = function() {
            window.location = $rootScope.waave_url;

            setTimeout(function(){
                window.location = $rootScope.redirectUrl;
            }, 50);
        };

        /**
         * Close banner
         */
        $rootScope.closeBanner = function() {
            $('.banner').hide();
            Helper.setCookie('bannerClosed', 9);
        }

        /**
         * Check if user needs to login
         */
        $rootScope.$on('$locationChangeStart', function (event, next, current) {

            // redirect to login page if not logged in and trying to access a restricted page
            var restrictedPage = Router.isPathRestricted();

            var loggedIn = User.isLoggedIn();

            if (restrictedPage && !loggedIn) {
                // user is not logged in

                // if user try to open one of these pages, remember it as intended path
                if( Router.shouldRememberIntendedPath() ){
                    $rootScope.globals.intended = $location.path();
                }

                // redirect to login page
                $location.path('/login');
            }
            else if( loggedIn ){
                // check expired token
                AwsCognito.checkTokenExpiration(function(status, resp) {
                    console.log(status);
                    // user is logged in
                    if (status) {
                        // check if braintree token exists, but don't check if user is on cart page
                        // because there we are also getting token, and if the user refreshed page 
                        // we would have two api token requests
                        if( $.inArray($location.path(), ['/money-cart', '/drink-cart', '/money-credit-card-payment', '/drink-credit-card-payment', '/login', '/register', '/']) === -1 ){
                            // user is not on cart page, get token
                            Braintree.getToken(function(token, status){
                                if( status == 200 ) $rootScope.braintree = { token: token };
                            });
                        }

                        // init pusher if it was not initialized yet
                        if( ! window.pusher_init ){
                            // Pusher init
                            var pusher = $pusher(window.pusher);
                            var channel = pusher.subscribe('web-app-'+$rootScope.globals.currentUser.id);

                            channel.bind('creditWasUpdated', function(data) {
                                console.log('creditWasUpdated event was detected');
                                User.getCredit();
                            });

                            window.pusher_init = true;
                        }
                    }
                    else {
                        //alert(resp);
                        // redirect to login page
                        $location.path('/logout');
                    }

                });

            }
        });

        /**
         * on route change success
         * - set body class
         */
        $rootScope.$on('$routeChangeSuccess', function (event, currentRoute) {

            if( typeof currentRoute.controller == 'undefined' ){
                class_name = '';
            }
            else{
                // convert camel case to snake case
                var class_name = currentRoute.controller.replace(/([A-Z])/g, function($1){return "-"+$1.toLowerCase();});

                // first remove Controller from name
                class_name = class_name.slice(1, -11);
            }

            // set body class
            $rootScope.bodyClass = class_name;

            if( typeof $routeParams.event_name != 'undefined'){
                // if event is removed from hash redirect back to event
                var current = window.location.hash.substr(1);

                if( current == '/' ){
                    $location.path('/event');
                }
            } else {
                // Get facebook meta
                $rootScope.facebookMeta = Helper.getFacebookMetaData();
                $rootScope.redirectUrl = Helper.getRedirectUrl();
                $rootScope.waave_url = Helper.getWaaveUrl();
                $rootScope.displayCustomBanner = Helper.checkShowCustomerBanner();
            }
        });

        /**
         * check if page has all the necessary
         * data so it can be opened
         */
        $rootScope.$on('$locationChangeStart', function (event, next, current) {

            switch( $location.path() ){
                case '/menu'                :  Router.redirectIfVenueIsNotSelected();              break;
                case '/venues'              :  Router.redirectIfUserIsNotSelected('drink');        break;
                case '/select-money-amount' :  Router.redirectIfUserIsNotSelected('send-money');   break;
                case '/drink-cart'          :  Router.redirectIfSomethingIsNotSelected();          break;
                case '/drink-receipt'       :  Router.redirectIfSomethingIsNotSelected();          break;
                case '/money-cart'          :  Router.redirectIfMoneyIsNotSelected();              break;
                case '/money-receipt'       :  Router.redirectIfMoneyIsNotSelected();              break;
            }

            // scroll to top
            $timeout(function(){
                $(window).scrollTop(0);
            }, 200);
        });
}]);

app.config(['$httpProvider', '$compileProvider', 'localStorageServiceProvider', 
    function ($httpProvider, $compileProvider, localStorageServiceProvider) {

        // set prefix for local storage
        localStorageServiceProvider.setPrefix('waave_');

        // disable debug mode for performance boost
        $compileProvider.debugInfoEnabled(false);

        // fix for sending post to php
        $httpProvider.defaults.transformRequest = function(data){
            if (data === undefined) return data;
            return $.param(data);
        };
        $httpProvider.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
        $httpProvider.defaults.headers.put['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';

        // check if request was unauthorized
        $httpProvider.interceptors.push('CheckUnauthorized');
    }]);


// plugin config
angular.module('infinite-scroll').value('THROTTLE_MILLISECONDS', 500);